import styled, { keyframes } from 'styled-components'
import { complementaryColor } from 'uiComponents/constants/colors'
import { ElementLayers } from 'uiComponents/constants/layers'

const growAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(-5px)
  }

  to {
    opacity: 1;
    transform: translateY(0px)
  }
`

const DropdownBox = styled.div`
  display: inline-block;
  position: absolute;
  min-width: 100%;
  max-height: 160px;
  margin-top: 10px;
  animation: ${growAnimation} 200ms linear;
  border: none;
  border-radius: 2px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 10px 15px 0 rgba(0, 0, 0, 0.16);
  background-color: ${complementaryColor};
  overflow: auto;
  z-index: ${ElementLayers.modal};
`

export default DropdownBox
